module.exports = __webpack_public_path__ + "img/img-relay-step3.a21cd10a.svg";